import _classCallCheck from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _inherits from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
/**
 * @copyright 2015-present (c) commenthol
 * @license ISC
 */

import HolidaysParser from 'date-holidays-parser';
import { data } from './data.js';

/**
 * @class
 * @param {String|Object} country - if object use `{ country: {String}, state: {String}, region: {String} }`
 * @param {String} [state] - specifies state
 * @param {String} [region] - specifies region
 * @param {Object} [opts] - options
 * @param {Array|String} opts.languages - set language(s) with ISO 639-1 shortcodes
 * @param {String} opts.timezone - set timezone
 * @param {Array} opts.types - holiday types to consider
 * @example
 * ```js
 * new Holiday('US', 'la', 'no') // is the same as
 * new Holiday('us.la.no')       // is the same as
 * new Holiday({ country: 'us', state: 'la', region: 'no'})
 * ```
 */
export var Holidays = /*#__PURE__*/function (_HolidaysParser) {
  _inherits(Holidays, _HolidaysParser);
  var _super = _createSuper(Holidays);
  function Holidays(country, state, region, opts) {
    _classCallCheck(this, Holidays);
    return _super.call(this, data, country, state, region, opts);
  }
  return Holidays;
}(HolidaysParser);